<template>
  <div>
    <div v-if="pageSize.loading" class="loading-indicator">
      <div class="spinner"></div>
      <p style="margin-left:8px;">Cargando...</p>
    </div>
    <dialog-postal-code
      @close="closeDialogHandleEditDistributionData"
      @update="update"
      :id="id"
      :serviceId="serviceId"
      :sectorId="sectorId"
      :disabled="disabled"
      :isVisible="editDistributionData"
      :postalCodesLit="distributions"
    />

    <dialog-load-postal-code
      @close="closeDialogHandleEditDistributionDataLoad"
      @update="update"
      :isVisible="editDistributionDataLoad"
    />

    <dialog-history-coverage
      @close="closeDialogHandleC"
      @update="update"
      :address="addressC"
      :service="serviceC"
      :disabled="disabledC"
      :isVisible="isVisibleC"
    />

    <dialog-upload-coverage
      :visible="uploadCSVDialogVisible"
      @close="closeUploadCSVDialog"
      @update="update"
    />

    <dialog-delete-by-service
      :visible="deleteByServiceDialog"
      @close="closeDeleteByServiceDialog"
      @update="update"
    />

    <!-- BLUE Header -->
    <div class="header">
      <el-row>
        <el-col :span="20" :offset="2">
          <h1>
            Paquetería
            <el-select
              v-model="carrier"
              @change="editCarrier"
              placeholder="Select"
              filterable
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>

            Servicio
            <el-select
              v-model="service"
              @change="editCarrier"
              placeholder="Select"
              filterable
            >
              <el-option
                v-for="item in options_service[carrier]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>

            Código postal
            <el-input
              :disabled="pageSize.loading"
              v-model="code"
              @change="editCarrier"
              class="postalcode"
              autocomplete="off"
              clearable
              maxlength="5"
            >
            </el-input>
          </h1>
        </el-col>
      </el-row>
    </div>
    <!-- END BLUE Header -->

    <!-- Table -->
    <el-row>
      <el-col :span="20" :offset="2">
        <el-card class="box-card">
          <div
            slot="header"
            style="display: flex; justify-content: space-between;"
          >
            <el-select
              :disabled="pageSize.loading"
              v-model="pageSize.value"
              style="width: 75px;"
              @change="onChangePageSize($event)"
            >
              <el-option
                style="width: 75px;"
                v-for="item in pageSize.options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>

            <div v-if="isSupervisor">
              <el-button type="primary" @click="openUploadCSVDialog"
                >Subir coberturas en CSV</el-button
              >

              <el-button type="danger" @click="openDeleteByServiceDialog"
                >Eliminar todas las coberturas por servicio</el-button
              >

              <el-button
                type="primary"
                icon="el-icon-plus"
                @click="handleEditDistributionDataLoad()"
              >
                Agregar/Modificar código postal
              </el-button>
            </div>
          </div>

          <el-table :data="distributions" style="width: 100%" stripe>
            <el-table-column v-if="isAdmin" width="40">
              <template slot-scope="scope">
                <el-popconfirm
                  confirm-button-text="Si"
                  cancel-button-text="No, Salir"
                  icon="el-icon-info"
                  iconColor="red"
                  title="¿Estás seguro de eliminarlo?"
                  @confirm="handleDeleteDistribution(scope.$index, scope.row)"
                >
                  <el-button
                    size="mini"
                    slot="reference"
                    icon="el-icon-delete-solid"
                    type="danger"
                    circle
                  >
                  </el-button>
                </el-popconfirm>
              </template>
            </el-table-column>

            <el-table-column
              label="Cobertura"
              width="111"
              align="center"
              prop="covered"
              sortable
            >
              <template slot-scope="props">
                <div
                  v-if="props.row.covered"
                  style="cursor: pointer"
                  @click="
                    openHistory(
                      props.row.uuid,
                      props.row.serviceUuid,
                      props.row.disabled
                    )
                  "
                >
                  <el-tag
                    class="blob green"
                    size="mini"
                    effect="dark"
                    type="success"
                  >
                    Si
                  </el-tag>
                </div>
                <div
                  v-else
                  style="cursor: pointer"
                  @click="
                    openHistory(
                      props.row.uuid,
                      props.row.serviceUuid,
                      props.row.disabled
                    )
                  "
                >
                  <el-tag size="mini" effect="dark" type="danger">
                    No
                  </el-tag>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              label="Codigo Postal"
              prop="postalCode"
              align="center"
              width="150"
              sortable
            >
              <template slot-scope="props">
                <h4>
                  {{ props.row.postalCode }}
                </h4>
                <small>
                  {{ props.row.updated_at | timeAgo }}
                </small>
              </template>
            </el-table-column>

            <el-table-column
              property="state"
              label="Estado"
              align="center"
              width="140"
              sortable
            >
              <template slot-scope="props">
                <span>{{ props.row.state }}</span>
              </template>
            </el-table-column>

            <el-table-column
              property="city"
              label="Ciudad"
              align="center"
              width="140"
              sortable
            >
              <template slot-scope="props">
                <span>{{ props.row.city }}</span>
              </template>
            </el-table-column>

            <el-table-column
              property="sector"
              label="Sector"
              align="center"
              width="150"
              sortable
            >
              <template slot-scope="props">
                <span>{{ props.row.sector }}</span>
              </template>
            </el-table-column>

            <el-table-column
              property="carrier"
              label="Paquetería"
              align="center"
              width="140"
              sortable
            >
              <template slot-scope="props">
                <h4>{{ props.row.carrier }}</h4>
              </template>
            </el-table-column>

            <el-table-column
              property="service"
              label="Servicio"
              align="center"
              width="200"
              sortable
            >
              <template slot-scope="props">
                <h4>{{ props.row.service }}</h4>
              </template>
            </el-table-column>

            <el-table-column
              property="disabled"
              label="Deshabilitado"
              align="center"
              width="140"
              sortable
            >
              <template slot-scope="props">
                <h4>{{ props.row.disabled || "Ningúno" }}</h4>
              </template>
            </el-table-column>

            <el-table-column
              label="Ocurre"
              align="center"
              width="120"
              prop="isOcurre"
              sortable
            >
              <template slot-scope="props">
                <div v-if="props.row.isOcurre">
                  <el-tag size="mini" effect="plain" type="warning">
                    Ocurre
                  </el-tag>
                </div>
                <div v-else>
                  <el-tag size="mini" effect="dark" type="primary">
                    No
                  </el-tag>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              label="Días de espera"
              align="center"
              prop="updated_at"
              width="150"
              sortable
            >
              <template slot-scope="props">
                <i class="el-icon-date"></i>
                {{ props.row.days }} Dias
              </template>
            </el-table-column>

            <el-table-column align="center">
              <template slot-scope="scope">
                <el-button
                  v-if="isSupervisor"
                  size="mini"
                  icon="el-icon-edit"
                  round
                  @click="handleEditDistributionData(scope.$index, scope.row)"
                  >Editar
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>
    <!-- END Table -->
    <br />
  </div>
</template>

<script>
import { mapState } from "vuex";
import DialogPostalCode from "@/components/DialogPostalCode";
import DialogLoadPostalCode from "@/components/DialogLoadPostalCode";
import DialogHistoryCoverage from "@/components/HistoryCoverage";
import DialogDeleteByService from "@/components/DialogDeleteByService";
import DialogUploadCoverage from "@/components/DialogUploadCoverage";
import { CSApi } from "@/libraries/api";

export default {
  name: "Home",
  components: {
    DialogLoadPostalCode,
    DialogPostalCode,
    DialogHistoryCoverage,
    DialogUploadCoverage,
    DialogDeleteByService,
  },
  data() {
    return {
      editDistributionProvider: false,
      editDistributionData: false,
      editDistributionDataLoad: false,
      uploadCSVDialogVisible: false,
      deleteByServiceDialog: false,

      distributions: [],
      id: null,
      serviceId: null,
      sectorId: null,
      disabled: null,

      addressC: "",
      serviceC: "",
      disabledC: null,
      isVisibleC: false,

      options: [],
      options_service: [],

      carrier: "All",
      service: "All",
      code: "",

      pageSize: {
        options: [
          {
            value: "50",
          },
          {
            value: "100",
          },
          {
            value: "150",
          },
          {
            value: "200",
          },
          {
            value: "250",
          },
          {
            value: "300",
          },
        ],
        value: "50",
        loading: false,
      },
    };
  },
  methods: {
    async update() {
      try {
        // postalcode?carrier=FEDEX&service=STANDARD_OVERNIGHT&code=64001
        // `postalcode?carrier=${this.carrier}&service=STANDARD_OVERNIGHT&code=64001`

        // Filter By
        let params = "";
        if (this.carrier !== "All") {
          params += `carrier=${this.carrier}&`;
        }

        if (this.service !== "All") {
          params += `service=${this.service}&`;
        }

        if (this.code !== "") {
          params += `postalCode=${this.code}&`;
        }

        this.pageSize.loading = true;
        const response = await CSApi().get(
          `/coverage/address/service?${params}page=1&pageSize=${this.pageSize.value}`
        );

        const { data } = response.data;

        // Transform
        this.distributions = data.map((record) => ({
          uuid: record.addressUUID,
          name:
            record.name ??
            `${record.carrierName.toLowerCase()}-${record.serviceType.toLowerCase()}`,
          carrier: record.carrierName,
          service: record.serviceType,
          serviceUuid: record.serviceUUID,
          covered: record.covered,
          days: record.days,
          isOcurre: record.isOcurre,
          outOfArea: false,
          outOfPickup: false,
          disabled: record.disabled,
          state: record.state,
          city: record.city,
          postalCode: record.postalCode,
          sector: record.sector,
        }));
        this.pageSize.loading = false;
      } catch (error) {
        this.$message({
          message: error,
          type: "error",
          duration: 8000,
        });
      }
    },
    async editCarrier() {
      this.handleEditCarrier();
      await this.update();
    },
    handleEditCarrier() {
      const query = {
        carrier: this.carrier,
        servie: this.service,
        code: this.code,
      };
      this.$router.replace({ query });
    },
    handleEditDistributionProvider(index, row) {
      this.id = row.uuid;
      this.serviceId = row.service;
      this.sectorId = row.sector;
      this.disabled = row.disabled;
      this.editDistributionProvider = true;
    },
    closeDialogHandleEditDistributionProvider() {
      this.editDistributionProvider = false;
    },

    handleEditDistributionData(index, row) {
      this.id = row.uuid;
      this.serviceId = row.serviceUuid;
      this.sectorId = row.sector;
      this.disabled = row.disabled;
      this.editDistributionData = true;
    },
    handleEditDistributionDataLoad(index, row) {
      this.editDistributionDataLoad = true;
    },
    handleNewDistributionData() {
      this.id = null;
      this.serviceId = null;
      this.sectorId = null;
      this.disabled = null;
      this.editDistributionData = true;
    },
    closeDialogHandleEditDistributionData() {
      this.editDistributionData = false;
    },
    closeDialogHandleEditDistributionDataLoad() {
      this.editDistributionDataLoad = false;
    },
    closeDialogHandleC() {
      this.isVisibleC = false;
    },
    openHistory(address, service, disabled) {
      this.addressC = address;
      this.serviceC = service;
      this.disabledC = disabled;
      this.isVisibleC = true;
    },
    openUploadCSVDialog() {
      this.uploadCSVDialogVisible = true;
    },
    closeUploadCSVDialog() {
      this.uploadCSVDialogVisible = false;
    },
    openDeleteByServiceDialog() {
      this.deleteByServiceDialog = true;
    },
    closeDeleteByServiceDialog() {
      this.deleteByServiceDialog = false;
    },

    async handleDeleteDistribution(index, row) {
      const options = {
        message: `El Código postal ${row.postalCode} ha sido eliminado.`,
        type: "warning",
        duration: 4000,
      };

      try {
        if (row.uuid) {
          const response = await CSApi().delete(
            `/coverage/postalCode/${row.uuid}/${row.serviceUuid}`
          );

          // If error
          if (!response?.data?.success)
            throw response?.data?.data?.error?.message || "Error";
        }
        this.$delete(this.distributions, index);
      } catch (error) {
        options.showClose = true;
        options.message = error;
        options.type = "error";
      } finally {
        this.$message(options);
      }
    },

    async onChangePageSize() {
      this.pageSize.loading = true;
      await this.update();
      this.pageSize.loading = false;
    },
  },
  computed: {
    ...mapState(["current_user"]),
    isAdmin() {
      return this.current_user.role == "admin";
    },
    isSupervisor() {
      return ["supervisor", "admin"].includes(this.current_user.role);
    },
  },
  async mounted() {
    const response = await CSApi().get(
      `coverage/service?searchBy=&page=1&pageSize=500`
    );

    const { data } = response.data;

    /*options: [{
        value: 'FEDEX',
        label: 'Fedex'
      }, {
        value: 'ESTAFETA',
        label: 'Estafeta'
      }],*/

    const carriers = {};
    for (const service of data.filter(
      (service) => service.countryCode == "MX"
    )) {
      carriers[service.carrier] ||= [];
      const newItem = service.service;
      carriers[service.carrier].indexOf(newItem) === -1
        ? carriers[service.carrier].push(newItem)
        : console.log("This item already exists");
    }

    const options = [
      {
        value: "All",
        label: "All",
      },
    ];

    const options_service = {
      All: [
        {
          value: "All",
          label: "All",
        },
      ],
    };

    for (const carrier in carriers) {
      options.push({
        value: carrier,
        label: carrier,
      });

      for (const service of carriers[carrier]) {
        options_service[carrier] ||= [];

        if (options_service[carrier].length == 0) {
          options_service[carrier].push({
            value: "All",
            label: "All",
          });
        }
        options_service[carrier].push({
          value: service,
          label: service,
        });
      }
    }

    this.options = options;
    this.options_service = options_service;

    this.handleEditCarrier();
    await this.update();
  },
};
</script>

<style scoped>
.loading-indicator {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5); /* Fondo semi-transparente */
  z-index: 9999; /* Asegura que esté en la parte superior */
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 5px solid #ccc;
  border-top-color: #333;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

h4 {
  margin: 2px;
}

.bottom {
  text-align: center;
  margin-top: 23px;
  line-height: 12px;
}

.button {
  padding: 0;
  float: right;
}

.postalcode {
  display: inline-block !important;
  position: relative !important;
  width: 100px !important;
}

.el-select {
  width: 230px;
}
</style>
